export default __webpack_public_path__ + "static/media/HH55555_tn.11f7896a.jpg";